import {Injectable} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs/operators';
import {Store} from '@ngrx/store';
import {IAppState} from '@app/core/store/state/app.state';
import {getCurrentState} from '@app/core/helpers';

declare var analytics;

@Injectable({
	providedIn: 'root',
})
export class SegmentService {

	constructor(
		private router: Router,
		private store: Store<IAppState>,
	) {
	}

	public start(): void {
		this.router.events.pipe(filter(val => val instanceof NavigationEnd)).subscribe(event => {
			analytics.page();
		});
	}

	public identifyUser(): void {
		const user = getCurrentState(this.store).session.user;

		if (user) {
			analytics.identify(user.id, {
				name: user.first_name + ' ' + user.last_name,
				quickManagerCreatedAt: user.created_at,
				quickManagerUserName: user.first_name + ' ' + user.last_name,
			});
		}
	}
}
